interface ProgressBarProps {
  current: number;    // 1-based — label "Pytanie X z Y"
  completed: number;  // passed questions — drives the % bar
  total: number;
}

/**
 * Thin progress bar + counter displayed above each question.
 * Progress reflects completed (passed) questions, not current position.
 */
export const ProgressBar = ({ current, completed, total }: ProgressBarProps) => {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="w-full">
      <div className="mb-1.5 flex items-center justify-between text-xs font-medium text-gray-400">
        <span>Pytanie {current} z {total}</span>
        <span>{pct}%</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-competition-accent transition-all duration-500"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};
